module.exports = __webpack_public_path__ + "static/img/empty.ab84ab0a.png";